import styled from "styled-components";
import {colors, devices} from "../../../utils/styled/_variables.styled";

const InfiosContentTeaserList = styled.div`
    .content__list {
        display: flex;
        margin-bottom: 64px;

        @media ${devices.tabletLarge} {
            margin-bottom: 48px;
        }

        @media ${devices.mobile} {
            margin-bottom: 44px;
        }
    }

    .content__list__wrapper {

        &:before {
            content: "";
            background-image: ${props => {
                switch (props.shadow) {
                    case 'top':
                        return `linear-gradient(0.28deg, rgba(0, 0, 0, 0) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)`;
                    case 'bottom':
                        return `linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0) 99.75%)`;
                    case 'both':
                        return `linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)`;
                    case 'none':
                        return `linear-gradient(0.28deg, rgba(0, 0, 0, 0) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0) 99.75%)`;
                    default:
                        return 'linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)';
                }
            }};
            display: block;
            position: absolute;
            width: 306px;
            height: 184px;
        }

        &:before {
            content: "";
            background-image: ${props => {
                switch (props.shadow) {
                    case 'top':
                        return `linear-gradient(0.28deg, rgba(0, 0, 0, 0) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)`;
                    case 'bottom':
                        return `linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0) 99.75%)`;
                    case 'both':
                        return `linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)`;
                    case 'none':
                        return `linear-gradient(0.28deg, rgba(0, 0, 0, 0) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0) 99.75%)`;
                    default:
                        return 'linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)';
                }
            }};
            display: block;
            position: absolute;
            width: 306px;
            height: 184px;
        }width: 306px;
        height: 184px;
        margin-right: 32px;
        @media ${devices.tabletLarge} {
            width: 208px;
            height: 126px;
            margin-right: 24px;
        }
        @media ${devices.mobile} {
            display: none;
            margin-right: unset;
        }

        .content__list__wrapper_image {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .content__list_container {
        max-width: ${props => props.fullWidth === "fullwidth" ? "757px" : "532px"};
        position: relative;
        @media ${devices.tabletLarge} {
            max-width: 440px;
        }
        @media ${devices.mobile} {
            height: unset;
            max-width: unset;
            max-height: 213px;
        }
    }

    .content__list_container_info {
        margin-bottom: 8px;
        @media ${devices.tabletLarge} {
            margin-bottom: 4px;
        }

        p {
            color: ${colors.gray3};
        }

        .content__list_icon {
            margin-right: 2px;
        }
    }

    .separator {
        display: inline-block;
        position: relative;
        height: 12px;
        top: 2px;
        width: 1px;
        background-color: ${colors.gray3};
        margin: 0 8px;
    }

    .content__list_container_texts {
        .content__list_title {
            margin-bottom: 12px;

            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;

            @media ${devices.tabletLarge} {
                margin-bottom: 8px;
                -webkit-line-clamp: 2;
            }
            @media ${devices.mobile} {
                font-size: 18px;
                max-height: 42px;
            }
        }

				.heading-5{
					font-size:19px;
				}

        .content__list_text {
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;

            margin-bottom: 28px;
            font-size:19px;
            line-height: 150%;
            height: 63px;
            text-overflow: ellipsis;
            @media ${devices.tabletLarge} {
                margin-bottom: 24px;
                height: 84px;
                -webkit-line-clamp: 4;
            }
            @media ${devices.mobile} {
                margin-bottom: 20px;
                height: unset;
                -webkit-line-clamp: 5;
            }
        }

        .content__list_link {
            justify-content: flex-start;
        }

        .margin {
            margin-top: 24px;
            @media ${devices.tabletLarge} {
                margin-top: 20px;
            }
            @media ${devices.mobile} {
                margin-top: 16px;
            }
        }
    }
`;

export {InfiosContentTeaserList};
